module.exports = __webpack_public_path__ + "static/media/delete-svgrepo-com.f3b8c4e3.svg";